import React from "react";

interface Props {
  className?: string;
}

export default function QualityIcon({className}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="54"
      className={className}
      viewBox="0 0 64 54"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-520 -1619)">
          <g transform="translate(520 1614)">
            <g>
              <path d="M0 0H64V64H0z"></path>
              <path
                fill="#64B4FA"
                fillRule="nonzero"
                d="M63.662 22.55L53.556 9.05a1.678 1.678 0 00-1.07-.652L32.274 5.023c-.182-.03-.37-.03-.552 0l-20.21 3.375c-.429.07-.813.304-1.072.651L.336 22.55a1.693 1.693 0 00.094 2.14l30.316 33.75a1.679 1.679 0 002.506 0l30.315-33.75c.54-.6.58-1.495.095-2.14zm-20.595-.676L32 52.374l-11.069-30.5h22.137zM22.591 18.5l9.408-9.426 9.408 9.426H22.59zm14.315-9.281l12.457 2.079-4.153 6.24-8.307-8.319h.003zm-18.118 8.32l-4.153-6.241L27.09 9.218l-8.303 8.32zm-3.059 1.488L5.675 21.04l6.033-8.06 4.021 6.045zm1.708 3.102l10.018 27.604L4.914 24.635l12.523-2.51v.003zm29.123 0l12.524 2.51-22.541 25.097L46.56 22.131v-.003zm1.708-3.102l4.022-6.045 6.033 8.06-10.055-2.015z"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}